// Shared Bali-timezone formatters extracted from BranchOrders.jsx so
// the small order-detail sub-components (TreatmentDateEditor,
// OrderHistoryPanel, HistoryDialog) can keep their formatting logic
// in lockstep with the parent view.
export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      timeZone: "Asia/Makassar", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      timeZone: "Asia/Makassar", day: "2-digit", month: "short", year: "numeric",
    });
  } catch { return iso; }
}
